import React, { useState, useRef, useEffect } from 'react';
import styles from '../styles/InputSection.module.css';

function InputSection({ onSendMessage, isLoading, prefilledValue = '', onPrefilledClear }) {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  // Set prefilled value when it changes
  useEffect(() => {
    if (prefilledValue) {
      setMessage(prefilledValue);
    }
  }, [prefilledValue]);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [message]);

  const handleSend = async () => {
    if (!message.trim() || isLoading) return;

    await onSendMessage(message);
    setMessage('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={styles.inputSection} data-tour="input-section">
      <div className={styles.inputSectionContent}>
        <div className={styles.inputContainer}>
          <textarea
            ref={textareaRef}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Message..."
            className={styles.textarea}
            disabled={isLoading}
            rows={1}
          />
          <button
            onClick={() => handleSend()}
            className={styles.sendButton}
            disabled={isLoading || !message.trim()}
            title="Send message"
          >
            ➤
          </button>
        </div>
      </div>
    </div>
  );
}

export default InputSection;
